// autolayout/fontsize - S48.2a.
// calcularFontSize(lineas, ancho, alto)
//   - lineas: Array<string>
//   - ancho: numero (en las mismas unidades que se va a renderizar; mm).
//   - alto:  numero (mm).
//   Retorna fontSize (numero) que hace caber todas las lineas en el bloque.
//
// Heuristica simple (sin medir contra canvas real):
//   - line height aprox = fontSize * 1.2 (sin libs).
//   - width ratio aprox: 1 char ~= fontSize * 0.55 (texto medio).
//   - Empieza en un fontSize candidato (8) y reduce hasta caber, minimo 4.

const MIN_FONT = 4;
const MAX_FONT = 14;
const LINE_HEIGHT_RATIO = 1.2;
const CHAR_WIDTH_RATIO = 0.55;

export function calcularFontSize(lineas, ancho, alto) {
  const arr = Array.isArray(lineas) ? lineas : [];
  const w = Number(ancho) || 0;
  const h = Number(alto) || 0;
  if (arr.length === 0 || w <= 0 || h <= 0) return MIN_FONT;

  let maxLineLen = 0;
  for (let i = 0; i < arr.length; i += 1) {
    const ln = String(arr[i] || '');
    if (ln.length > maxLineLen) maxLineLen = ln.length;
  }
  if (maxLineLen === 0) return MIN_FONT;

  for (let fs = MAX_FONT; fs >= MIN_FONT; fs -= 1) {
    const lineH = fs * LINE_HEIGHT_RATIO;
    const totalH = arr.length * lineH;
    const charW = fs * CHAR_WIDTH_RATIO;
    const lineW = maxLineLen * charW;
    if (totalH <= h && lineW <= w) return fs;
  }
  return MIN_FONT;
}
